<mat-card>
  <mat-card-title>
    <div fxLayoutAlign="start" fxFlex="20%">
      Merchants
    </div>
    <div fxLayoutAlign="start" fxFlex="50%">
      <mat-form-field fxFill>
        <mat-label>Search</mat-label>
        <input matInput placeholder="Search" #search>
      </mat-form-field>
    </div>
    <div fxLayoutAlign="end" fxFlex="30%">
      <a routerLink="/merchant" color="accent" mat-raised-button routerLinkActive="active" *ngIf="isEnabled('create')">Create New Merchant</a>
    </div>
  </mat-card-title>

  <div id="list">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- MID Column -->
      <ng-container matColumnDef="mid">
        <mat-header-cell *matHeaderCellDef> MID </mat-header-cell>
        <mat-cell *matCellDef="let merchant">
          <a routerLink="/merchants/{{ merchant.location.id }}">{{ merchant.location.id }}</a>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let merchant">
          <a routerLink="/merchants/{{ merchant.location.id }}">{{ merchant.location.name }}</a>
        </mat-cell>
      </ng-container>

      <!-- Gateway Column -->
      <ng-container matColumnDef="gatewayName">
        <mat-header-cell *matHeaderCellDef> Gateway </mat-header-cell>
        <mat-cell *matCellDef="let merchant">
          <a routerLink="/merchants/{{ merchant.location.id }}">{{ getGatewayName(merchant) }}</a>
        </mat-cell>
      </ng-container>

      <!-- IsActive Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let merchant">
          <a routerLink="/merchants/{{ merchant.location.id }}">{{merchant.location.status}}</a>
        </mat-cell>
      </ng-container>

      <!-- Last Modified Date Time Column -->
      <ng-container matColumnDef="lastModifiedDateUtc">
        <mat-header-cell *matHeaderCellDef> Last Modified </mat-header-cell>
        <mat-cell *matCellDef="let merchant">
          <a routerLink="/merchants/{{ merchant.location.id }}">{{ formatUtcIsoStringToLocal(merchant.location.lastModifiedDateTime) }}</a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
</mat-card>
